import { PageLink } from '../../../../../../../assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Estudantes',
    path: '/commercial/students',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
